<template>
  <div class="slider">
    <el-carousel trigger="click" height="400px" :interval="3000" arrow="always">
      <el-carousel-item v-for="item in imgList" :key="item.id">
        <img class="img" :src="item.img" alt="">
      </el-carousel-item>
    </el-carousel>
    <!-- <div class="cover"></div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      imgList: [
        {
          id: 1,
          img: require('../assets/banner01.jpg')
        },
        {
          id: 2,
          img: require('../assets/banner02.jpg')
        },
        {
          id: 3,
          img: require('../assets/banner03.jpg')
        },
        {
          id: 4,
          img: require('../assets/banner04.jpg')
        },
        {
          id: 5,
          img: require('../assets/banner05.jpg')
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.slider {
  position: relative;
  background-color: rgba($color: #000000, $alpha: 0.4);
  .cover {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 185px;
    background: url(../assets/cover.png) center center no-repeat;
    z-index: 1000;
  }
  .img {
    display: block;
    height: 100%;
    width: 100%;
  }
}
</style>
